<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 30px;
}
#app fieldset {
  border: solid 1px #A9A9A9;
      border-radius: 8px;
}
#app legend {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue